const getImageFormat = (ext: string) => {
  return ext === ".svg" ? "svg" : "auto";
};

export { getImageFormat };
